'use client';

import { logInOauth } from "@/actions/auth";
import { event } from "@/lib/analytics/gtag";
import { useTranslation } from "@/lib";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useRouter } from "next/navigation";
import { useCallback, useState, useTransition } from "react";
import { ENV } from "@/lib/env";

export const SocialConnect = ({ locale, destination }: { locale: string, destination?: string }) => {
    const [isPending, startTransition] = useTransition();
    const [error, setError] = useState<string | null>(null);
    const router = useRouter();
    const { t } = useTranslation(locale);
    const target = destination ?? `/${locale}/profile`;

    const handleOauthLogin = useCallback(async (provider: string, tokenId: string) => {
        setError(null);
        startTransition(async () => {
            const result = await logInOauth(provider, tokenId);
            if (!result.isError) {
                event({
                    action: 'login',
                    category: 'auth',
                    label: provider,
                    method: 'oauth'
                });
                router.push(target);
            } else {
                setError(result.message || 'errors.unexpected_error');
            }
        });
    }, [router, target]);

    if (!ENV.GOOGLE_CLIENT_ID) return null;

    return (
        <GoogleOAuthProvider clientId={ENV.GOOGLE_CLIENT_ID}>
            <div className="space-y-3">
                {error && (
                    <p className="text-sm text-red-600 text-center">{error}</p>
                )}
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        if (credentialResponse.credential) {
                            handleOauthLogin('google', credentialResponse.credential);
                        }
                    }}
                    onError={() => {
                        setError('errors.google_auth_failed');
                    }}
                    useOneTap
                />
            </div>
        </GoogleOAuthProvider>
    );
};
